var searchWorker = {
  index: null,
  _siteLink: null,
  _playerScriptLoaded: false,
  _playerScriptPath: '/wp-content/themes/nmi/jsmin/wavesurfer.min.js',
  contentSelector: '.archive-content',
  pages: 0,
  page: 1,
  per_page: 9,
  max_pages: 7,
  results: [],
  filters: {
    search: '',
    author: [],
    audience: [],
    product: [],
    topic: [],
    playlists: [],
    news_type: null,
  },
  siteLink: function () {
    return window.location.origin;
  },
  search: function (val) {
    searchWorker.filters.search = val;
    searchWorker.page = 1;
    searchWorker.updateUrl();
    searchWorker.update();
  },
  news_type: function (val) {
    searchWorker.filters.news_type = val;
    searchWorker.page = 1;
    searchWorker.updateUrl();
    searchWorker.update();
  },
  author: function (val) {
    searchWorker.filters.author = val;
    searchWorker.page = 1;
    searchWorker.updateUrl();
    searchWorker.update();
  },
  playlists: function (val) {
    searchWorker.filters.playlists = val;
    searchWorker.page = 1;
    searchWorker.updateUrl();
    searchWorker.update();
  },
  audience: function (val) {
    searchWorker.filters.audience = val;
    searchWorker.page = 1;
    searchWorker.updateUrl();
    searchWorker.update();
  },
  topic: function (val) {
    searchWorker.filters.topic = val;
    searchWorker.page = 1;
    searchWorker.updateUrl();
    searchWorker.update();
  },
  product: function (val) {
    searchWorker.filters.product = val;
    searchWorker.page = 1;
    searchWorker.updateUrl();
    searchWorker.update();
  },
  clearIncommingData: function (val) {
    return val.replace(':', ' ').replace('^', ' ').replace('~', ' ').replace('+', ' ').replace('-', ' ').replace('—', ' ').replace('  ', ' ').replace('  ', ' ');
  },
  update: function () {
    var result = searchWorker.index.search(searchWorker.clearIncommingData(searchWorker.filters.search));
    var unfiltredResults = result.map(function (item) {
      return searchIndex.find(function (post) {
        if (item.ref == post.id) {
          return post;
        }
      });
    });
    searchWorker.results = [];
    for (var i in unfiltredResults) {
      var include = true;
      if (searchWorker.filters.author.length) {
        if (unfiltredResults[i].author.filter(function (n) {
          return searchWorker.filters.author.indexOf(n) !== -1;
        }).length === 0) {
          include = false;
        }
      }
      if (searchWorker.filters.news_type !== null) {
        if (searchWorker.filters.news_type !== unfiltredResults[i].news_type) {
          include = false;
        }
      }
      if (searchWorker.filters.audience.length) {
        if (unfiltredResults[i].audience.filter(function (n) {
          return searchWorker.filters.audience.indexOf(n) !== -1;
        }).length === 0) {
          include = false;
        }
      }
      if (searchWorker.filters.playlists.length) {
        if (unfiltredResults[i].playlists.filter(function (n) {
          return searchWorker.filters.playlists.indexOf(n) !== -1;
        }).length === 0) {
          include = false;
        }
      }
      if (searchWorker.filters.topic.length) {
        if (unfiltredResults[i].topic.filter(function (n) {
          return searchWorker.filters.topic.indexOf(n) !== -1;
        }).length === 0) {
          include = false;
        }
      }
      if (searchWorker.filters.product.length) {
        haveFilters = true;
        if (unfiltredResults[i].product.filter(function (n) {
          return searchWorker.filters.product.indexOf(n) !== -1;
        }).length === 0) {
          include = false;
        }
      }
      if (include) {
        searchWorker.results.push(unfiltredResults[i]);
      }
    }
    if (
            searchWorker.filters.search.length ||
            searchWorker.filters.author.length ||
            searchWorker.filters.news_type !== null ||
            searchWorker.filters.audience.length ||
            searchWorker.filters.playlists.length ||
            searchWorker.filters.topic.length ||
            searchWorker.filters.product.length) {
      $('#filter-reset').removeClass('disabled');
    }
    searchWorker.pages = Math.ceil(searchWorker.results.length / searchWorker.per_page);
    searchWorker.dispalyResults();
  },
  renderPressRelease: function (element, numberInRow) {
    return '\
      <div class="archive-item" data-aos="fade-up" data-aos-delay="' + (numberInRow * 250) + '">\n\
        <span class="image-wrap"><img class="item-image" src="' + element.image.url + '" alt="' + element.image.alt + '" width="' + element.image.width + '" height="' + element.image.height + '" /></span>\n\
        <span class="content">\n\
        <span class="title"><a class="h3 stretched-link" target="_blank" href="' + element.url + '" >' + element.title + '</a></span>\n\
        <span class="date-category">' + element.dateFormated + '<span class="separator">•</span>Media Coverage</span>\n\
          <span class="description">' + element.description + '</span>\n\
          <span class="readmore">Read More</span>\n\
      </span>\n\
      </div>';
  },

  renderNews: function (element, numberInRow) {
    return '\
      <div class="archive-item " data-aos="fade-up" data-aos-delay="' + (numberInRow * 250) + '">\n\
        <span class="image-wrap"><img class="item-image" src="' + element.image.url + '" alt="' + element.image.alt + '" width="' + element.image.width + '" height="' + element.image.height + '" /></span>\n\
        <span class="content">\n\
          <span class="title"><a class="h3 stretched-link" href="' + element.url + '">' + element.title + '</a></span>\n\
          <span class="date-category">' + element.dateFormated + '<span class="separator">•</span>' + (element.news_type ? 'Press Release' : 'Media Coverage') + '</span>\n\
          <span class="description">' + element.description + '</span>\n\
          <span class="readmore">Read More</span>\n\
        </span>\n\
      </div>';
  },
  renderAuthors: function (element, numberInRow) {
    return '\
      <div class="archive-item" data-aos="fade-up" data-aos-delay="' + (numberInRow * 250) + '">\n\
        <span class="image-wrap"><img class="item-image" src="' + element.image.url + '" alt="' + element.image.alt + '" width="' + element.image.width + '" height="' + element.image.height + '" /></span>\n\
        <span class="content">\n\
          <span class="title authorct"><a class="h3 stretched-link" href="' + element.url + '">' + element.title + '</a></span>\n\
          <span class="date-category authorct">' + element.position + '</span>\n\
          <span class="description">' + element.description + '</span>\n\
          <span class="readmore">Read More</span>\n\
        </span>\n\
      </div>';
  },
  renderCTA: function () {
    if (ctaBlock) {
      return '\
        <a class="CTABlock" data-aos="fade-up" href="' + ctaBlock.button.url + '"' + (ctaBlock.button.target.length ? ' target="' + ctaBlock.button.target + '"' : '') + '>' +
              '<span class="header">' + ctaBlock.header + '</span>' +
              '<span class="sub-header">' + ctaBlock['sub-header'] + '</span>' +
              '<span class="button">' + ctaBlock.button.title + '</span>' +
              '</a>';

    } else{
      return '';
    }
  },
  renderInsights: function (element, numberInRow) {
    return '\
      <div class="archive-item' + (!element.authorText ? ' no-author' : '') + '" data-aos="fade-up" data-aos-delay="' + (numberInRow * 250) + '">\n\
        <span class="image-wrap"><img class="item-image" src="' + element.image.url + '" alt="' + element.image.alt + '" width="' + element.image.width + '" height="' + element.image.height + '" /></span>\n\
        <span class="content">\n\
          <span class="title"><a class="h3 stretched-link" href="' + element.url + '">' + element.title + '</a></span>\n\
          ' + (element.authorText ? '<span class="author">By ' + element.authorText + (element.secondAuthorText ? ' & ' + element.secondAuthorText : '') + '</span>' : '') + '\n\
          <span class="description">' + element.description + '</span>\n\
          <span class="readmore">Read More</span>\n\
        </span>\n\
      </div>';
  },
  renderWebinars: function (element, numberInRow) {
    return '\
      <div class="archive-item' + (!element.webinar_status ? ' no-author' : '') + '" data-aos="fade-up" data-aos-delay="' + (numberInRow * 250) + '">\n\
        <span class="image-wrap"><img class="item-image lazy" data-src="' + element.image.url + '" src="data:image/svg+xml,%3Csvg%20xmlns=\'http://www.w3.org/2000/svg\'%20viewBox=\'0%200%20512%20512\'%3E%3C/svg%3E" alt="' + element.image.alt + '" width="' + element.image.width + '" height="' + element.image.height + '" /></span>\n\
        <span class="content">\n\
          <span class="title">\n\
            <a class="h3 stretched-link" ' + (element.webinar_status ? 'target="blank"' : '') + ' href="' + (element.webinar_status ? element.regLink : element.url) + '">' + element.title + '</a>\n\
          </span>\n\
          ' + (element.webinar_status ? '<span class="author">Upcoming Webinar</span>' : '') + '\n\
          <span class="description">' + element.description + '</span>\n\
          <span class="readmore">' + (element.webinar_status ? 'Register Now' : 'View Here') + '</span>\n\
        </span>\n\
      </div>';
  },
  renderCaseStudy: function (element, numberInRow) {
    return '\
      <div class="archive-item  no-author" data-aos="fade-up" data-aos-delay="' + (numberInRow * 250) + '">\n\
        <span class="image-wrap"><img class="item-image lazy" data-src="' + element.image.url + '" src="data:image/svg+xml,%3Csvg%20xmlns=\'http://www.w3.org/2000/svg\'%20viewBox=\'0%200%20512%20512\'%3E%3C/svg%3E" alt="' + element.image.alt + '" width="' + element.image.width + '" height="' + element.image.height + '" /></span>\n\
        <span class="content">\n\
          <span class="title"><a class="h3 stretched-link" href="' + element.url + '">' + element.title + '</a></span>\n\
          <span class="description">' + element.problem + '</span>\n\
          <span class="readmore">Read More</span>\n\
        </span>\n\
      </div>';
  },
  renderWhitepaper: function (element, numberInRow) {
    return '\
      <div class="archive-item  no-author" data-aos="fade-up" data-aos-delay="' + (numberInRow * 250) + '">\n\
        <span class="image-wrap"><img class="item-image lazy" data-src="' + element.image.url + '" src="data:image/svg+xml,%3Csvg%20xmlns=\'http://www.w3.org/2000/svg\'%20viewBox=\'0%200%20512%20512\'%3E%3C/svg%3E" alt="' + element.image.alt + '" width="' + element.image.width + '" height="' + element.image.height + '" /></span>\n\
        <span class="content">\n\
          <span class="title"><a class="h3 stretched-link" href="' + element.url + '">' + element.title + '</a></span>\n\
          <span class="description">' + element.description + '</span>\n\
          <span class="readmore">Read More</span>\n\
        </span>\n\
      </div>';
  },
  renderPodcasts: function (element, numberInRow) {
    var renderPlayer = false;
    var html = '\
      <div data-aos="fade-up" class="podcast-card">\n\
        <div class="row align-items-stretch">\n\
          <div class="col-12 col-lg-6 order-lg-2">\n\
          <div class="bar">\n\
    ';
    if (element.podcast_links.apple_podcasts_link.length ||
            element.podcast_links.google_podcasts_link.length ||
            element.podcast_links.spotify_link.length) {
      html += '\
          <div class="follow-podcast">\n\
                <div class="dropdown">\n\
                    <a class="button" href="#" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n\
                        Follow our Podcast\n\
                    </a>\n\
                    <div class="dropdown-menu">\n\
        ';
      if (element.podcast_links.apple_podcasts_link.length) {
        html += '\
          <div class="podcast-link">\n\
              <i class="podcast-link-icon-apple"></i>\n\
              <a href="' + element.podcast_links.apple_podcasts_link + '" target="_blank">Apple Podcasts</a>\n\
          </div>\n\
          ';
      }
      if (element.podcast_links.google_podcasts_link.length) {
        html += '\
          <div class="podcast-link">\n\
              <i class="podcast-link-icon-google"></i>\n\
              <a href="' + element.podcast_links.google_podcasts_link + '" target="_blank">Google Podcasts</a>\n\
          </div>\n\
          ';
      }
      if (element.podcast_links.spotify_link.length) {
        html += '\
          <div class="podcast-link">\n\
              <i class="podcast-link-icon-spotify"></i>\n\
              <a href="' + element.podcast_links.spotify_link + '" target="_blank">Spotify</a>\n\
          </div>\n\
          ';
      }
      html += '\
                    </div>\n\
                </div>\n\
            </div>\n\
        ';
    }
    html += '<div class="share-download">';
    if (element.podcast_type == 'upload') {
      html += '\
              <a href="' + element.link + '" download>\n\
                  <i class="download-icon"></i>\n\
              </a>\n\
        ';
    }
    html += searchWorker.shareDropdown(element.url);
    html += '</div>';
    html += '</div>';
    if (element.podcast_type == 'upload') {
      html += '\
          <section class="audio-player" id="player' + element.id + '">\n\
            <button class="play-button" data-playbtn="' + searchWorker.siteLink() + '/wp-content/themes/nmi/images/podcast/podcast-play-blue.png" data-pausebtn="' + searchWorker.siteLink() + '/wp-content/themes/nmi/images/podcast/podcast-pause-blue.png">\n\
                <img\n\
                        class="play-button-icon"\n\
                        src="' + searchWorker.siteLink() + '/wp-content/themes/nmi/images/podcast/podcast-play-blue.png"\n\
                        alt="Play Button"\n\
                />\n\
            </button>\n\
            <div class="player-body">\n\
                <div id="waveform" class="waveform" data-audio="' + element.link + '" style="background-image: url(\'' + searchWorker.siteLink() + '/wp-content/themes/nmi/images/podcast/placeholder.png\')"></div>\n\
                <div class="controls d-none d-lg-block">\n\
                    <div class="timecode">\n\
                        <span id="totalDuration" class="total-duration"></span>\n\
                    </div>\n\
                </div>\n\
            </div>\n\
          </section>\n\
        ';
    } else if (element.podcast_type == 'embed') {
      html += '<div class="embed-podcast lazy" data-lazy-function="lazyPlayer">' + element.code + '</div>';
    }
    html += '\
        </div>\n\
        <div class="col-12 col-lg-6 order-lg-1">\n\
          <div class="podcast-info">';
    html += '\
            ' + (element.caption ? '<div class="caption">' + element.caption + '</div>' : '') + '\n\
            <a href="' + element.url + '"><span class="h3">' + element.title + '</span>\n\
            <span class="podcast-short-desc">' + element.description + '</span>\n\
                <span class="lrn-more">Learn More</span></a>\n\
            </div>\n\
        </div>\n\
    </div>\n\
</div>\n\
';

    return html;
  },
  renderPlayer: function (element) {
    if ($(element).hasClass('player-rendered')) {
      return false;
    }
    var player_id = $(element).find('.waveform').attr('id');
    var playButton = $('.play-button', element);
    var playButtonIcon = $('.play-button-icon', element);
    var waveform = $('.waveform', element);
    var currentTime = $('.total-duration', element);
    var totalDuration = $('.total-duration', element);

    var wavesurfer = WaveSurfer.create({
      container: '#' + player_id,
      responsive: true,
      height: 100,
      barWidth: '3',
      waveColor: '#b8b8b8',
      progressColor: '#21aeff',
      pixelRatio: 1,
      backend: 'MediaElement'
    });

    $(element).addClass('player-rendered');

    const togglePlay = () => {
      wavesurfer.playPause()
      const isPlaying = wavesurfer.isPlaying()
      if (isPlaying) {
        $(playButtonIcon).attr("src", playButton.attr("data-pausebtn"));
      } else {
        $(playButtonIcon).attr("src", playButton.attr("data-playbtn"));
      }
    }

    $(playButton).on("click", function () {
      if ($(waveform).hasClass('player-ready')) {
        togglePlay();
      } else {
        wavesurfer.once('ready', wavesurfer.play.bind(wavesurfer));
        wavesurfer.load($(waveform).attr("data-audio"));
        $(playButtonIcon).attr("src", playButton.attr("data-pausebtn"));
      }
    });

    const formatTimecode = seconds => {
      return new Date(seconds * 1000).toISOString().substr(11, 8);
    }

    // Wavesurfer event listeners
    wavesurfer.on("ready", () => {
      // Set audio track total duration
      const duration = wavesurfer.getDuration();
      $(totalDuration).html(formatTimecode(duration));
      $(waveform).addClass('player-ready');
      $(playButtonIcon).addClass('player-ready');
    })

    // Sets the timecode current timestamp as audio plays
    wavesurfer.on("audioprocess", () => {
      const time = wavesurfer.getCurrentTime();
      $(currentTime).html(formatTimecode(time));
    })
    // Resets the play button icon after audio ends
    wavesurfer.on("finish", () => {
      $(playButtonIcon).attr("src", $(playButton).attr("data-playbtn"));
    });
  },
  shareDropdown: function (link) {
    return '\n\
    <div class="dropdown">\n\
    <a class="share-dropdown-toggle dropdown-toggle" aria-label="Share" role="button" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n\
        <span class="share-button-icon"></span>\n\
    </a>\n\
    <div class="share-dropdown-menu dropdown-menu">\n\
        <a class="dropdown-item" href="https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(link) + '" target="_blank"><i class="share-icon-facebook"></i>Facebook</a>\n\
        <a class="dropdown-item" href="https://x.com/share?url=' + encodeURI(link) + '" target="_blank"><i class="share-icon-x"></i>X</a>\n\
        <a class="dropdown-item" href="https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURI(link) + '" target="_blank"><i class="share-icon-linkedin"></i>LinkedIn</a>\n\
        <a class="dropdown-item" href="mailto:?subject=I wanted you to see this&amp;body=Check out this link: ' + encodeURI(link) + '."><i class="share-icon-email"></i>Email</a>\n\
    </div>\n\
</div>';
  },

  renderElement: function (element, numberInRow) {
    switch (element.type) {
      case "news":
        return searchWorker.renderNews(element, numberInRow);
        break;
      case "press-release":
        return searchWorker.renderPressRelease(element, numberInRow);
        break;
      case "insights":
        return searchWorker.renderInsights(element, numberInRow);
        break;
      case "case-studies":
        return searchWorker.renderCaseStudy(element, numberInRow);
        break;
      case "whitepapers":
        return searchWorker.renderWhitepaper(element, numberInRow);
        break;
      case "podcasts":
        return searchWorker.renderPodcasts(element, numberInRow);
        break;
      case "webinars":
        return searchWorker.renderWebinars(element, numberInRow);
        break;
      case "authors":
        return searchWorker.renderAuthors(element, numberInRow);
        break;
    }
  },
  urlForPage: function (pageNum) {
    if (pageNum < 1) {
      pageNum = 1;
    }
    if (pageNum > searchWorker.pages) {
      pageNum = searchWorker.pages;
    }
    var params = [];
    if (searchWorker.filters.search.length) {
      params.push('search=' + encodeURIComponent(searchWorker.filters.search));
    }
    if (searchWorker.filters.topic.length) {
      params.push('topic=' + encodeURIComponent(searchWorker.filters.topic.join(',')));
    }
    if (searchWorker.filters.author.length) {
      params.push('author=' + encodeURIComponent(searchWorker.filters.author.join(',')));
    }
    if (searchWorker.filters.audience.length) {
      params.push('audience=' + encodeURIComponent(searchWorker.filters.audience.join(',')));
    }
    if (searchWorker.filters.playlists.length) {
      params.push('playlists=' + encodeURIComponent(searchWorker.filters.playlists.join(',')));
    }
    if (searchWorker.filters.news_type !== null) {
      params.push('news_type=' + (searchWorker.filters.news_type ? 1 : 0));
    }
    if (pageNum > 1) {
      params.push('pageNum=' + pageNum);
    }


    return searchWorker.baseUrl + (params.length ? '?' + params.join('&') : '');
  },
  pagination: function () {
    html = '';
    if (searchWorker.pages > 1) {
      html += '<div class="pagination">';
      html += '<a onclick="searchWorker.switchPage(' + (searchWorker.page - 1) + ', event);" class="prev-page" href="' + searchWorker.urlForPage(searchWorker.page - 1) + '" aria-label="Previous page"><span>Previous page</span></a>';
      html += '<ul>';
      var pageElements = [];
      if (searchWorker.pages <= searchWorker.max_pages) {
        for (var i = 1; i <= searchWorker.pages; i++) {
          pageElements.push(i);
        }
      } else if (searchWorker.page < 3 || searchWorker.page > searchWorker.pages - 2) {
        for (var i = 1; i <= 3; i++) {
          pageElements.push(i);
        }
        pageElements.push(null);
        for (var i = searchWorker.pages - 2; i <= searchWorker.pages; i++) {
          pageElements.push(i);
        }
      } else {
        pageElements.push(1);
        pageElements.push(null);
        for (var i = searchWorker.page - 1; i <= searchWorker.page + 1; i++) {
          pageElements.push(i);
        }
        pageElements.push(null);
        pageElements.push(searchWorker.pages);
      }
      for (i in pageElements) {
        html += '<li class="' + (pageElements[i] == searchWorker.page ? 'current ' : '') + (pageElements[i] === null ? 'spacer' : '') + '">';
        if (pageElements[i] == searchWorker.page || pageElements[i] == null) {
          html += '<span>' + (pageElements[i] === null ? '•••' : pageElements[i]) + '</span>';
        } else {
          html += '<a class="page" onclick="searchWorker.switchPage(' + pageElements[i] + ', event);" href="' + searchWorker.urlForPage(pageElements[i]) + '" aria-label="Next Page">' + (pageElements[i] === null ? '...' : pageElements[i]) + '</a>';
        }
        html += '</li>';
      }
      html += '</ul>';
      html += '<a  onclick="searchWorker.switchPage(' + (searchWorker.page + 1) + ', event);" class="next-page" href="' + searchWorker.urlForPage(searchWorker.page + 1) + '" aria-label="Next Page"><span>Next page</span></a>';
      html += '</div>';
    }
    return html;
  },
  switchPlaylists: function (playlist, event) {
    event.preventDefault();
    searchWorker.topic([]);
    if (typeof (window.topicChoises) !== 'undefined') {
      window.topicChoises.removeActiveItems();
    }
    searchWorker.playlists([playlist]);
    searchWorker.scrollTop(true);
    return false;
  },
  resetFilters: function () {
    $('#search-filter').val('');
    searchWorker.filters = {
      search: '',
      author: [],
      audience: [],
      topic: [],
      product: [],
      playlists: [],
      news_type: null,
    };
    if (typeof (window.topicChoises) !== 'undefined') {
      window.topicChoises.removeActiveItems();
    }
    if (typeof (window.audienceChoises) !== 'undefined') {
      window.audienceChoises.removeActiveItems();
    }
    if (typeof (window.productChoises) !== 'undefined') {
      window.productChoises.removeActiveItems();
    }
    if (typeof (window.autorChoises) !== 'undefined') {
      window.autorChoises.removeActiveItems();
    }
    searchWorker.page = 1;
    searchWorker.updateUrl();
    searchWorker.update();
    $('#filter-reset').addClass('disabled');
  },
  switchPage: function (page, event) {
    event.preventDefault();
    console.log('switchPage');
    searchWorker.scrollTop();
    var page = parseInt(page);
    if (page < 1 || page > searchWorker.pages || page == searchWorker.page) {
      return false;
    }
    searchWorker.page = page;
    searchWorker.updateUrl();
    searchWorker.dispalyResults();
    return false;
  },
  updateUrl: function () {
//    window.history.pushState({}, document.title, searchWorker.urlForPage(searchWorker.page));
  },
  scrollTop: function (force) {
    var force = force || false;
    var topElement = $('.archive-filters').length ? $('.archive-filters') : $('.archive-content');
    if (force || ($(window).scrollTop() > $(topElement).offset().top - ($('.header-top').length ? $('.header-top').height() : 0) - $(topElement).height())) {
      window.scroll({
        top: $(topElement).offset().top - ($('.header-top').length ? $('.header-top').height() : 0) - $(topElement).height(),
        left: 0,
        behavior: 'smooth'
      });
    }
  },
  init: function () {
    searchWorker.baseUrl = window.location.pathname;
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('pageNum')) {
      searchWorker.page = parseInt(urlParams.get('pageNum'));
    }
    if (urlParams.has('author')) {
      searchWorker.filters.author = urlParams.get('author').split(',');
      if (typeof (window.autorChoises) !== 'undefined') {
        window.autorChoises.setChoiceByValue(searchWorker.filters.author);
      }
    }
    if (urlParams.has('news_type')) {
      searchWorker.filters.news_type = (urlParams.get('news_type') === '1');
      if ($('.filter-button').length) {
        $('.filter-button').removeClass('active');
        if (searchWorker.filters.news_type) {
          $('.filter-button.button-press').addClass('active');
        } else {
          $('.filter-button.button-media').addClass('active');
        }
      }
    }
    if (urlParams.has('topic')) {
      searchWorker.filters.topic = urlParams.get('topic').split(',');
      if (typeof (window.topicChoises) !== 'undefined') {
        window.topicChoises.setChoiceByValue(searchWorker.filters.topic);
      }
    }
    if (urlParams.has('audience')) {
      searchWorker.filters.audience = urlParams.get('audience').split(',');
      if (typeof (window.audienceChoises) !== 'undefined') {
        window.audienceChoises.setChoiceByValue(searchWorker.filters.audience);
      }
    }
    if (urlParams.has('playlists')) {
      searchWorker.filters.playlists = urlParams.get('playlists').split(',');
      if (typeof (window.audienceChoises) !== 'undefined') {
        window.audienceChoises.setChoiceByValue(searchWorker.filters.playlists);
      }
    }
    if (urlParams.has('search')) {
      var rawStr = urlParams.get('search');
      var encodedStr = rawStr.replace(/[\u00A0-\u9999<>\&]/g, function (i) {
        return '&#' + i.charCodeAt(0) + ';';
      });
      searchWorker.filters.search = encodedStr;
      $('#search-filter').val(searchWorker.filters.search);
    }
    searchWorker.update();

  },
  showEmpty: function () {
    $(searchWorker.contentSelector).html('<div class="nothing-found">We could not find any results matching your criteria. Please remove some filters to widen the scope of the search</div>');
  },

  dispalyResults: function () {
    $(searchWorker.contentSelector).html('');
    var counter = 0;
    var numberInRow = 0;
    var html = '';
    if (searchWorker.results.length > 0) {
      for (var i = ((searchWorker.page - 1) * searchWorker.per_page); (i < searchWorker.results.length && counter < searchWorker.per_page); i++) {
        html += searchWorker.renderElement(searchWorker.results[i], numberInRow);
        counter++;
        numberInRow++;
        if (numberInRow === 3) {
          numberInRow = 0;
        }
        if (counter === 3) {
          html += searchWorker.renderCTA();
        }
      }
      html += searchWorker.pagination();
      $(searchWorker.contentSelector).append(html);
      if (window.w3tc_lazyload) {
        window.w3tc_lazyload.update();
      }
      $('.podcast-card .audio-player').each(function (index, element) {
        if (!searchWorker._playerScriptLoaded) {
          $.getScript(searchWorker.siteLink() + searchWorker._playerScriptPath, function () {
            searchWorker._playerScriptLoaded = true;
            searchWorker.renderPlayer(element);
          });
        } else {
          searchWorker.renderPlayer(element);
        }
      });
    } else {
      searchWorker.showEmpty();
    }
  }

};



$(window).on('load', function () {
  if (typeof (searchIndex) == 'object') {
    window.lazyFunctions.lazyPlayer = function (element) {
      $(element).find('script').each(function (i, elem) {
        var script = document.createElement('script');
        script.setAttribute('src', $(elem).prop('src'));
        document.body.appendChild(script);
      });
    };

    searchWorker.index = lunr(function () {
      var bannedSymbols = ['®', '@', '©', '™'];
      this.ref('id');
      this.field('title', {boost: 10});
      this.field('description');
      for (var i in searchIndex) {
        var fixedIndex = searchIndex[i];
        for (var n in bannedSymbols) {
          fixedIndex['title'] = fixedIndex['title'].replace(bannedSymbols[n], ' ');
          fixedIndex['description'] = fixedIndex['description'].replace(bannedSymbols[n], ' ');
        }
        this.add(fixedIndex);
      }
    });
    searchWorker.init();
  }

$(document).ready(function() {
  
  const filterSelect = document.getElementById('video');
  filterSelect.addEventListener('change', () => {
    const selectedCategory = filterSelect.value;
    document.querySelectorAll(".video_playlist").forEach(item => {
      if (selectedCategory === '' || item.dataset.category === selectedCategory) {
        item.style.display = 'block';
      } else {  
        item.style.display = 'none';
      }
    });
  });

  $(document).on("click", ".modal-link", function () { 
    $('body').addClass("modal-open");
     var youtubeId = $(this).data('id');  
     var html = '<iframe src="https://fast.wistia.net/embed/iframe/'+youtubeId+'?seo=true&videoFoam=false" allow="autoplay; fullscreen" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" msallowfullscreen width="560" height="300"></iframe>';
     $( html ).appendTo('.custom-modal-inner');
  }); 

  $('.close-modal').on('click', function() {
    $('body').removeClass("modal-open");
    $('.custom-modal-inner').empty();
  });

  $('.carousel_slick').each(function(index, element) {
    var $sliderBox = $(element).find('.slider-box');
    var $sliderControls = $sliderBox.next('.slider-controls');
    var carousel_video = $sliderBox.slick({
      autoplay: false,
      dots: true,    

      arrows: false,
      loop: true,        
      autoplaySpeed: 6000,
      pauseOnHover: true,    
      pauseOnFocus: false, 
      slidesToShow: 3,
      slidesToScroll: 3,
      centerMode: false,    
      cssEase: 'ease-out', 
      appendDots: $sliderControls, 
      responsive: [
        { 
          breakpoint: 992,     
          settings: {
            centerMode: true,
            centerPadding: '0',
            slidesToShow: 1
          }
        },     
        {
          breakpoint: 320, 
          settings: { 
            centerMode: true,
            centerPadding: '1',
            slidesToShow: 1    
          }
        }
      ]    
    });

    carousel_video.on('afterChange', function(event, slick, currentSlide) {
      var activeDotEl = $sliderControls.find('.slick-dots').find('li.slick-active');
      activeDotEl.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  });

  $(document).on("click", ".modal-link", function () {
    $('body').addClass("modal-open");
     var youtubeId = $(this).data('id');  
     $('.youtubeVideoFrameModal').attr('src', 'https://www.youtube.com/embed/'+ youtubeId +'?autoplay=1');

  }); 
  
  $('.close-modal').on('click', function() {
    $('body').removeClass("modal-open");
    $('.youtubeVideoFrameModal').attr('src', 'about:blank');      
  });

});

  window.sliderInitialized = false;

  $(document).one('scroll touchstart mouseenter', function () {
    if (window.sliderInitialized) {
      return;  
    }
    window.sliderInitialized = true;
    $('.carusel').slick({
      centerMode: false,
      variableWidth: true,
      arrows: false,
      loop: true,
      autoplay: true,
      autoplaySpeed: 6000,
      pauseOnHover: true,
      pauseOnFocus: false,
      cssEase: 'ease-out',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            centerMode: true,
            centerPadding: '0',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 320,
          settings: {
            centerMode: true,
            centerPadding: '1',
            slidesToShow: 1
          }
        }
      ]
    });
    $('.slider-prev-button').click(function () {
      $('.carusel').slick('slickPrev');
    })

    $('.slider-next-button').click(function () {
      $('.carusel').slick('slickNext');
    });
  });
  if (window.innerWidth >= 992) {
    AOS.init({
      once: true,
      disable: function () {
        var maxWidth = 992;
        return window.innerWidth < maxWidth;
      }
    });
  }

  $('.CTABlock[href^="#"]').click(function (e) {
    e.preventDefault();
    var navHeight;
    var target = $(this.hash);
    navHeight = $(".header-top").outerHeight();
    if ($("#wpadminbar").length > 0) {
      navHeight += $("#wpadminbar").outerHeight();
    }
    navHeight += 50;

    target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
    if (target.length) {
      $("html, body").animate(
              {
                scrollTop: target.offset().top - navHeight
              },
              1000
              );
      return false;
    }
  });

});
